import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    hasLogin:false,
    testDialogShow:false
  },
  mutations: {
    setLogin(state, val){
      state.hasLogin=val;
    },
    setTestDialog(state, val){
      state.testDialogShow=val;
    },
  },
  actions: {},
  modules: {}
});
